import React from 'react';

import { ResizeableRectangle } from '@vlabs/monokit/shared/ui/canvas-items';

import type { ResizeableRectangleProps } from './types';

export function RegionRectangle({
  rect,
  isSelected = false,
  onSelect = undefined,
  onUpdate = undefined,
  bbox = undefined,
  ...rectProps
}: ResizeableRectangleProps): React.JSX.Element {
  return (
    <ResizeableRectangle
      bbox={bbox}
      draggable={isSelected}
      isSelected={isSelected}
      onSelect={onSelect}
      onUpdate={onUpdate}
      rect={rect}
      shadowForStrokeEnabled={false}
      strokeScaleEnabled={false}
      transformerProps={{
        borderEnabled: false,
        rotateEnabled: false,
        ignoreStroke: true,
        keepRatio: false,
      }}
      {...rectProps}
    />
  );
}
